<div class="nav-slot" [blazeSlotNode]="slots?.slotNodesData?.['nsHostType:Sidebar']">
  <ng-container *ngTemplateOutlet="slots?.templates?.['nsHostType:Sidebar'] || null" />
</div>
